// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"61143fb6","453":"726ee2d3","591":"bc42a851","680":"979f7674"}[chunkId] + ".chunk.js";
};